"use client";

import { motion } from "framer-motion";
import clsx from "clsx";
import Logo from "./Logo";
import MobileMenu from "./MobileMenu";
import { hardcodedContent } from "@/app/(site)/_lib/global-content";

type MobileNavbarProps = {
	isMenuOpen: boolean;
	onOpenMenu: () => void;
	onCloseMenu: () => void;
};

export default function MobileNavbar({ isMenuOpen, onOpenMenu, onCloseMenu }: MobileNavbarProps) {
	return (
		<motion.div
			className={clsx(
				"relative z-50 mx-3.5 w-full overflow-hidden sm:hidden",
				isMenuOpen && "relative bg-[#f2f2f2]/60 backdrop-blur-[20px]",
				!isMenuOpen && "rounded-lg bg-[#f2f2f2]/50 backdrop-blur-[10px]",
			)}
			initial={{
				marginLeft: "0.875rem",
				marginRight: "0.875rem",
			}}
			animate={{
				marginLeft: isMenuOpen ? 0 : "0.875rem",
				marginRight: isMenuOpen ? 0 : "0.875rem",
			}}
			transition={{
				duration: 0.3,
				ease: "easeInOut",
			}}
		>
			<div
				className={clsx(
					"flex w-full items-center justify-between pt-3.5 pb-3.5 pl-5",
					isMenuOpen && "pr-5",
					!isMenuOpen && "pr-3.5",
				)}
			>
				<Logo onClick={isMenuOpen ? onCloseMenu : undefined} />

				<button
					onClick={isMenuOpen ? onCloseMenu : onOpenMenu}
					className={clsx(
						"text-cap-m text-graphite-black/50 active:text-graphite-black hover:text-graphite-black transition-colors",
					)}
					aria-label={isMenuOpen ? "Close menu" : "Open menu"}
				>
					{isMenuOpen ? hardcodedContent.mobileNavbar.close : hardcodedContent.mobileNavbar.menu}
				</button>
			</div>

			<MobileMenu isOpen={isMenuOpen} onClose={onCloseMenu} />
		</motion.div>
	);
}
